import { CommonFormGrid } from 'components/form/grid';
import { FormHeading } from 'components/form/heading';
import { FormTextField } from 'components/form/textfield';
import { EB } from 'components/layout/error-boundary';
import { FormContext } from 'contexts/form';
import { IssuerDoc } from 'lib/interfaces/database/issuer';
import { useContext, useState } from 'react';

export const IssuerForm = () => {
  const { data, setData } = useContext(FormContext);

  const [defaultData] = useState<Partial<IssuerDoc>>(data);

  return (
    <EB>
      <CommonFormGrid columns="1">
        <FormHeading label="Issuer" />

        <FormTextField
          label="Name"
          defaultValue={defaultData.name}
          onChange={(v) => {
            const payload: Partial<IssuerDoc> = {
              name: v,
            };
            setData(payload);
          }}
          required
        />
      </CommonFormGrid>
    </EB>
  );
};
